import { apiWobaBackend } from "@/services/api-woba-backend";
import { AxiosError } from "axios";
import {
  CreateDownsellApiParams,
  CreateDownsellApiResponse,
} from "./create-downsell.types";

export const CreateDownsellAPi = async (params: CreateDownsellApiParams) => {
  try {
    const downsellData = {
      bookingId: params.data.bookingId,
      cancelStrategy: params.data.cancelStrategy,
      poContractId: params.data.contractId,
    };

    const { data } = await apiWobaBackend.post<CreateDownsellApiResponse>(
      `/companies/${params.data.companyId}/packages/${params.data.packageId}/downsell`,
      downsellData,
    );

    return {
      success: true,
      data: data,
    };
  } catch (err) {
    const error = err as AxiosError;

    return {
      success: false,
      data: error?.response?.data as CreateDownsellApiResponse,
    };
  }
};
